export default {
  'brand-images-border-radius': 'var(--brand-images-border-radius)',
  'brand-cards-border-radius': 'var(--brand-cards-border-radius)',
};
